module.exports = __webpack_public_path__ + "static/img/banner.6f88a6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/traditional/company/banner.jpg
// module id = DW5U
// module chunks = 0